import { generatedV1iApi } from '~/api';
import { createDataDependencies } from '~/utils/DataStore';

export default createDataDependencies({
  currentContact: generatedV1iApi.contacts.showSelf,
});
